"use strict";

exports.__esModule = true;
exports.EventName = void 0;

/* eslint-disable camelcase */
let EventName = /*#__PURE__*/function (EventName) {
  EventName["RouteChange"] = "gatsby-route-change";
  EventName["HeaderMenuClick"] = "header_menu_click";
  EventName["RetailerClick"] = "retailer_link_click";
  EventName["ViewSearchResults"] = "view_search_results";
  EventName["ViewElement"] = "view_element";
  EventName["ViewItem"] = "view_item";
  EventName["ViewItemList"] = "view_item_list";
  EventName["GenerateLead"] = "generate_lead";
  EventName["SelectPromotion"] = "select_promotion";
  EventName["SelectItem"] = "select_item";
  EventName["RetailerLinkConfirmation"] = "retailer_link_click_confirmation";
  EventName["RetailerLinkRejection"] = "retailer_link_click_rejection";
  return EventName;
}({});

exports.EventName = EventName;